export const STANDARD_WIDTH = 424
export const STANDARD_WRAPPER_WIDTH = `${STANDARD_WIDTH}px`
export const TASK_FILTERS_TOOLBAR_HEIGHT = 40
